import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MatExpansionPanel } from "@angular/material/expansion";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-compi",
  templateUrl: "./compi.component.html",
  styleUrls: ["./compi.component.css"],
})
export class CompiComponent implements OnInit {
  li: any;
  list = [];
  lit: any;
  lis = [];
  lif: any;
  lift = [];
  faql: any;
  faqlist = [];
  displayStyles = "block";
  constructor(private http: HttpClient) {}

  openAccordion(panel: MatExpansionPanel) {
    panel.open();
  }

  closeAccordion(panel: MatExpansionPanel) {
    panel.close();
  }
  ngOnInit(): void {
    // this.displayStyles="block";
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    // this.http.get('https://api3.ecell.in/eureka24/getFaq/')
    // .subscribe(Response => {
    //   this.faql=Response;
    //   this.faqlist=this.faql.faq;
    // });

    this.http
      .get(environment.API_URL + "getGenRules/")
      .subscribe((Response) => {
        if (Response) {
        }
        this.li = Response;
        this.list = this.li.gen_rules;
        // console.log(this.list)
      });
    this.http
      .get(environment.API_URL + "getZonalRules/")
      .subscribe((Response) => {
        if (Response) {
        }
        this.lit = Response;
        this.lis = this.lit.zonal_rules;
        // console.log(this.list)
      });
    this.http
      .get(environment.API_URL + "getQueRules/")
      .subscribe((Response) => {
        if (Response) {
        }
        this.lif = Response;
        this.lift = this.lif.que_rules;
        // console.log(this.list)
      });
    this.displayStyles = "none";
  }
}
